module.exports = __webpack_public_path__ + "static/img/download_formulario.7b9a1fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download_formulario.jpg
// module id = 1dKm
// module chunks = 1